import { SET_SMART_BANNER, SET_SPLASHSCREEN_VIEW } from '../../constants';
const initialState = {
    showSplashScreen: true,
    showSmartBanner: true,
};
const splashLoaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SPLASHSCREEN_VIEW:
            return {
                ...state,
                showSplashScreen: action.showSplashScreen,
            };
        case SET_SMART_BANNER:
            return {
                ...state,
                showSmartBanner: action.showSmartBanner,
            };
        default:
            return state;
    }
};
export default splashLoaderReducer;
